import { useSplitTestBranch } from '../api/lendingApi/lendingApiQueries';
import { ISOLATED_SPLIT_TESTS } from '../constants';
import { useLocale } from './useLocale';

export function useIsInDEOpenBankingCopyTest() {
  const { isDE } = useLocale();
  const { splitTestBranch, isLoading, isError } = useSplitTestBranch(
    ISOLATED_SPLIT_TESTS.DE_OPEN_BANKING_COPY_TEST,
    { enabled: isDE, cookieOverride: true },
  );

  return {
    isLoading: isLoading,
    isIncludedInOBCopyTest: !isError && splitTestBranch === 'INCLUDE',
  };
}
